import { useCallback, useEffect, useState } from "react";
import AgentPreferencesAPI from "../api/AgentPreferencesAPI";

const useAgentPreferenceCatalog = () => {
	const [catalog, setCatalog] = useState([]);
	const [loading, setLoading] = useState(true);
	const [error, setError] = useState(null);

	const refresh = useCallback(async () => {
		setLoading(true);
		setError(null);

		try {
			const result = await AgentPreferencesAPI.getCatalog();
			setCatalog(result?.items || []);
		} catch (err) {
			setError(err.message);
		} finally {
			setLoading(false);
		}
	}, []);

	useEffect(() => {
		refresh();
	}, [refresh]);

	const createItem = async (label) => {
		try {
			await AgentPreferencesAPI.createCatalogItem(label);
			await refresh();
			return { success: true };
		} catch (err) {
			return { success: false, error: err.message };
		}
	};

	const renameItem = async (id, label) => {
		try {
			await AgentPreferencesAPI.renameCatalogItem(id, label);
			await refresh();
			return { success: true };
		} catch (err) {
			return { success: false, error: err.message };
		}
	};

	const toggleItem = async (id, enabled) => {
		try {
			await AgentPreferencesAPI.toggleCatalogItem(id, enabled);
			await refresh();
			return { success: true };
		} catch (err) {
			return { success: false, error: err.message };
		}
	};

	const deleteItem = async (id) => {
		try {
			await AgentPreferencesAPI.deleteCatalogItem(id);
			await refresh();
			return { success: true };
		} catch (err) {
			return { success: false, error: err.message };
		}
	};

	return { catalog, loading, error, refresh, createItem, renameItem, toggleItem, deleteItem };
};

export default useAgentPreferenceCatalog;
